// Ukraine
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  dashboard: {
    analytics_title: "Аналітика по пацієнтам",
    download_count_title: "Кількість установок за весь час по іграх",
    total_users: "Всього користувачів",
    total_profit: "Загальний прибуток",
    profit: "Прибуток",
    profit_popover: "Прибуток за всі активні ігри активних користувачів",
    number_of_users: "Активних користувачів",
    price_per_game: "Ціна за гру",
    active: "Активні",
    not_active: "Не активні",
    downloads: "Завантаження",
    home_page: "Головна",
    edit_price: "Редагувати ціну за гру",
    enter_price: "Введіть ціну",
    max_length: "Максимальна довжина",
    cancel: "Відмінити",
    save: "Зберегти",
    total: "Всього"
  },
  faq: {
    faq_page: "FAQ",
    title: "Поширені запитання",
    contact_us: "Напишіть нам"
  },
  instruction: {
    instruction_page: "Інстрокція",
    title: "Інструкції",
    contact_us: "Напишіть нам",
    how_send: "Як відправляти повідомлення",
    presentation: "Презентація ОКОЛО"
  },
  notifications: {
    notifications_page: "Розсилка повідомлень",
    sending_messages: "Розсилка повідомлень",
    specify_recipients: "Вкажіть одержувачів повідомлень",
    which_game: "В яку гру відправляти?",
    who_should: "Кому відправляти?",
    all_patients: "Всім пацієнтам",
    everyone_active_game: "Всім з активною грою",
    anyone_inactive_game: "Всім з неактивною грою",
    specify_from_list: "Вказати зі списку",
    use_post_template: "Використовувати шаблон повідомлення",
    new: "Новий",
    template_1: "Шаблон  1",
    template_2: "Шаблон  2",
    template_3: "Шаблон  3",
    name: "Назва",
    enter_name: "Введіть заголовок повідомлення",
    max_length: "Максимальна довжина",
    message: "Повідомлення",
    enter_text: "Введіть текст повідомлення",
    send: "Надіслати повідомлення",
    save_template: "Зберегти шаблон",
    last_active: "Останній активний",
    want_send: "Ви впевнені, що хочете надіслати це повідомлення пацієнтам?",
    sent: "Надіслано",
    sent_message: "Повідомлення успішно надіслано обраним пацієнтам",
    of_course: "Так",
    not_sent: "Повідомлення не надіслано",
    list_empty:
      "Список одержувачів порожній. Виберіть одержувачів вручну або змініть налаштування фільтра.",
    error: "Помилка",
    contact_admin: "Зверніться до адміністратора або спробуйте пізніше.",
    cancel: "Відмінити"
  },
  login: {
    welcome: "Ласкаво просимо в OKOLO",
    pass: "Пароль",
    forgot: "Забули пароль?",
    login: "Увійти",
    enter_email_for_reset: "Введіть Вашу електронну адресу, щоб скинути пароль",
    reset_pass: "Скинути пароль",
    back: "Назад",
    about_us: "Про нас",
    contact_us: "Зв'язатися з нами",
    enter_email: "Введіть Email",
    enter_password: "Введіть пароль",
    email_not_valid: "Значення не є дійсною адресою електронної пошти",
    provide_correct_data: "Будь ласка, введіть правильні дані!"
  },
  header_menu: {
    patients_btn: "Пацієнти",
    add_patient: "Додати пацієнта",
    email_not_valid: "Значення не є дійсною адресою електронної пошти.",
    enter_password: "Введіть пароль.",
    min_length: "Мінімальна довжина",
    max_length: "Максимальна довжина",
    last_name: "Прізвище",
    first_name: "Ім'я",
    phone_number: "Номер телефону",
    comment: "Коментар",
    pass: "Пароль",
    enter_last_name: "Введіть прізвище",
    enter_first_name: "Введіть ім'я",
    enter_phone_number: "Введіть номер телефону",
    enter_comment: "Введіть коментар",
    enter_pass: "Введіть пароль",
    enter_email: "Введіть Email",
    cancel: "Відміна",
    save: "Зберегти",
    for_instance: "Наприклад:",
    doctor_code: "Ваш код лікаря : "
  },
  footer: {
    news: "Новини"
  },
  topbar: {
    notification_user: "Повідомлення користувача"
  },
  patients: {
    patients: "Пацієнти",
    patients_list: "Список всіх Ваших пацієнтів",
    search_placeholder: "Поиск...",
    patient_page: "Сторінка пацієнта",
    active_before: "Було доступно до: ",
    active_until: "Доступно до: ",
    status_th: "СТАТУС",
    access_games_th: "ДОСТУП ДО ІГОР",
    full_name_th: "ПІБ",
    contacts_th: "КОНТАКТИ",
    finance_th: "ФІНАНСИ",
    comments_th: "КОМЕНТАР",
    not_active: "Не активний",
    active: "Активний"
  },
  patient: {
    patient: "Пацієнт",
    delete_patient: "Видалити пацієнта",
    edit_patient: "Редагувати пацієнта",
    min_length: "Мінімальна довжина",
    max_length: "Максимальна довжина",
    last_name: "Прізвище",
    first_name: "Ім'я",
    phone_number: "Номер телефону",
    comment: "Коментар",
    pass: "Пароль",
    enter_last_name: "Введіть прізвище",
    enter_first_name: "Введіть ім'я",
    enter_phone_number: "Введіть номер телефону",
    enter_comment: "Введіть коментар",
    cancel: "Скасування",
    save: "Зберегти",
    for_instance: "Наприклад:",
    active_user: "Активний користувач",
    inactive_user: "Неактивний користувач",
    total_time: "Загальний час",
    in_games_h: "в іграх (ч)",
    average_time: "Середній час",
    deactivate_patient: "Деактивувати пацієнта",
    activate_patient: "Активувати пацієнта",
    access: "Доступ",
    yes: "Так",
    no: "Ні",
    game_available_until: "Гра доступна до: ",
    by_levels: "По рівнях",
    by_time: "По часу",
    days: "Днів",
    levels_graph_by_date: "Графік рівнів гри по датах",
    time_m: "Час (м)",
    time: "Час",
    timeline_by_date: "Графік часу гри по датах",
    date_and_format: 'Дата "мм.дд"',
    want_remove_patient: "Ви впевнені, що хочете видалити пацієнта?",
    deleted: "Видаленно",
    patient_deleted: "Запис пацієнта успішно видалено",
    ok: "Зрозуміло",
    level_in_game: "Рівень пацієнта у грі",
    playing_time: "Час гри в годинах",
    level: "Рівень",
    create_date: "Дата реєстрації"
  },
  quick_user: {
    hello: "Вітаємо",
    doctor: "Доктор:",
    user_profile: "Профіль користувача",
    code: "Код:",
    exit: "Вихід"
  }
};
